import settings from './season1/settings.json'

export interface Venue {
  id: string
  display_name: string
}

export interface CabanaSettings {
  available_venues: Venue[]
  quote_mints: string[]
}

export const CABANA_SETTINGS: CabanaSettings = {
  available_venues: settings.available_venues,
  quote_mints: settings.quote_mints,
}
